export const neighborsLogoPath = `/neighbors.png`;
export const communityLogoPath = `/logo.png`;
export const neighborsFilledLogoPath = `/neighbors-filled-logo.png`;